/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GameMetadata
 */
export interface GameMetadata {
    /**
     * 
     * @type {string}
     * @memberof GameMetadata
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GameMetadata
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GameMetadata
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof GameMetadata
     */
    icon?: string;
}

/**
 * Check if a given object implements the GameMetadata interface.
 */
export function instanceOfGameMetadata(value: object): value is GameMetadata {
    return true;
}

export function GameMetadataFromJSON(json: any): GameMetadata {
    return GameMetadataFromJSONTyped(json, false);
}

export function GameMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function GameMetadataToJSON(json: any): GameMetadata {
    return GameMetadataToJSONTyped(json, false);
}

export function GameMetadataToJSONTyped(value?: GameMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'logo': value['logo'],
        'icon': value['icon'],
    };
}

